import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Row } from "reactstrap";
import { ToastContainer } from "react-toastify";

import Constants from "../../../constants/constants.js";
import SessionDesigner from "../session-designer/session-designer";
import TherapistSessionBank from "../therapist-session-bank/therapist-session-bank";
import OrganizationForm from "../organization-form/organization-form";
import Overview from "../therapist-dashboard/therapist-dashboard";
import PlayerArchive from "../player-archive/player-archive";
import PlayerGameSessions from "../player-game-sessions/player-game-sessions";
import PlayerDashboard from "../player-dashboard/player-dashboard";
import PlayerForm from "../player-form/player-form";
import PlayerSessionBank from "../player-session-bank/player-session-bank";
import PlayerTeamMembers from "../player-team-members/player-team-members";
import ResultsDashboard from "../player-activities/player-activities";
import RegionalManagerDashboard from "../manager-dashboard/regional-manager-dashboard.js";
import Sidebar from "../sidebar/sidebar";
import TeamMemberForm from "../team-member-form/team-member-form";
import CarePartnerDashboard from "../care-partner-dashboard/care-partner-dashboard";
import TeamMembers from "../team-members/team-members";
import PlayerGameSession from "../player-game-session/player-game-session";
import PlayerProgressDashboard from "../player-progress-dashboard/player-progress-dashboard";
import QuickPlay from "../quick-play/quick-play";
import OnlineRoomPage from "../online-room-list/online-room-page.js";
import PlayScreen from "../play-screen/play-screen";
import PlayScreenTimocco from "../play-screen/play-screen-timocco";

import HomePlay from "../home-play/home-play";
import HomePlayerDashboard from "../home-player-dashboard/home-player-dashboard.js";
import MetabaseDashboard from "../metabase-dashboard/metabase-dashboard.js";

import { setAuthToken, keepAlive } from "../../../modules/user";
import Leaderboard from "../leaderboard/leaderboard";

import worldCupBanner from "../../../images/world_cup_banner.png";
import "./scaffold.css";
import MasquaradeDropdown from "../../components/masquarade-dropdown/masquarade-dropdown.js";
import {
  setMasquaradeUsers,
  setMasquaradeUser,
} from "../../../modules/system/masquarade.js";
import {
  getMasquaradeUsers,
  masquaradeUser,
  revertMasquarade,
} from "../../../modules/system/masquarade_api";
import { withWhiteLabelContext } from 'react-whitelabel';
import {ConstantsModifier} from '../../../constants/constants';
import TournamentCreator from '../tournament-creator/tournament-creator';
import TournamentEditor from '../tournament-creator/tournament-editor';

import GamificationMenuToggler from "../gamification-menu/gamification-menu-toggler.js";
import DatadogUserTagger from "../datadog-user-tagger/datadog-user-tagger";

const KEEP_ALIVE_INTERVAL = 30;

class Scaffold extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lastKeepAlive: false,
    };
  }

  getScaffoldTemplate() {}

  adminRouter(isWorldCupUser) {
    const {label} = this.props;
    const playScreen = (label.playScreen.version === "multiplayer")?PlayScreen:PlayScreenTimocco;
    return (
        <div className="d-flex Scaffold-container">
          <Sidebar />
          <div className="flex-grow-1 Scaffold-content">
            {isWorldCupUser && (
              <div
                onClick={() => {
                  window.location =
                    process.env.REACT_APP_URL_PATH + "/leaderboard";
                }}
                className="world_cup_banner_container"
              >
                <img
                  alt="world_cup_banner"
                  className="world_cup_banner"
                  src={worldCupBanner}
                ></img>
              </div>
            )}
            <Switch>
              <Route exact path={"/play-screen"} component={playScreen} />
              <Route exact path={"/quick-play"} component={QuickPlay} />
              <Route exact path={"/restore-together"} component={OnlineRoomPage} />
              <Route exact path={"/"} component={playScreen} />
              <Route exact path={"/therapistDashboard"} component={Overview} />
              <Route path={"/stats-dashboard"} component={MetabaseDashboard} />

              <Route
                exact
                path={"/organizationForm"}
                component={OrganizationForm}
              />

              <Route exact path={"/teamMember"} component={TeamMemberForm} />
              <Route exact path={"/teamMembers"} component={TeamMembers} />
              <Route path={"/teamMember/:id"} component={TeamMemberForm} />

              <Route exact path={"/gameSession"} component={SessionDesigner} />
              <Route
                exact
                path={"/sessionBank"}
                component={TherapistSessionBank}
              />
              <Route path={"/gameSession/:id"} component={SessionDesigner} />

              <Route exact path={"/player"} component={PlayerForm} />
              <Route exact path={"/player/:id"} component={PlayerForm} />
              <Route
                exact
                path={"/player/:id/sessions"}
                component={PlayerGameSessions}
              />
              <Route
                exact
                path={"/player/:id/sessions/:player_game_session_id"}
                component={PlayerGameSession}
              />
              <Route
                exact
                path={"/player/:playerId/gameSession"}
                component={SessionDesigner}
              />
              <Route
                exact
                path={"/player/:playerId/gameSession/:id"}
                component={SessionDesigner}
              />
              <Route exact path={"/playerArchive"} component={PlayerArchive} />
              <Route
                path={"/player/:id/activities"}
                component={ResultsDashboard}
              />
              <Route
                path={"/player/:id/progressDashboard"}
                component={PlayerProgressDashboard}
              />
              <Route
                path={"/player/:id/dashboard"}
                component={PlayerDashboard}
              />
              <Route
                path={"/player/:id/sessionBank"}
                component={PlayerSessionBank}
              />
              <Route
                path={"/player/:id/teamMembers"}
                component={PlayerTeamMembers}
              />
              <Route path={"/player/:id/homePlay"} component={HomePlay} />
              {isWorldCupUser && (
                <Route path={"/leaderboard"} component={Leaderboard} />
              )}
              <Route exact path={"/tournament"} component={TournamentCreator} />
              <Route exact path={"/tournament/new"} component={TournamentEditor} />
              <Route exact path={"/tournament/:tournamentId"} component={TournamentEditor} />
            </Switch>
          </div>
        </div>
    );
  }

  onSearchChange(search_terms, token) {
    //TODO: use value to trigger search at the endpoint
    //TODO: pass result to dispatch to update the values
    console.log("value captured", search_terms);
    if (search_terms.length < 3) {
      this.props.dispatch(setMasquaradeUsers([], 0));
      return;
    }
    getMasquaradeUsers(search_terms, token).then((result) => {
      let masquaradeUsers = result.data.users;
      let masquaradeUserCount = result.data.userCount;
      console.log(masquaradeUsers);
      this.props.dispatch(
        setMasquaradeUsers(masquaradeUsers, masquaradeUserCount)
      );
    });
  }

  onSelectUser(user_id, token) {
    let selectedUser = this.props.masquaradeUsers.filter(
      (user) => user.id === user_id
    )[0];
    console.log(selectedUser);
    masquaradeUser(user_id, token).then((result) => {
      console.log(result.data);
      // this.props.dispatch(setMasquaradeUser(result.data.user))
      if (result.data && result.data.token) {
        this.props.dispatch(setMasquaradeUser(result.data.is_impersonated));
        setAuthToken(result.data.token);
        window.location = "/";
      }
    });
  }

  onRevertMasquarade(token) {
    revertMasquarade(token).then((result) => {
      if (result.data && result.data.token) {
        setAuthToken(result.data.token);
        window.location = "/";
      }
    });
  }

  renderAdminScaffold(user, profileRoute, isWorldCupUser) {
    const {
      masquaradeUsers,
      masquaradeUserCount,
      token,
      isMasquaraded,
    } = this.props;
    return (
      <Router>
      <div onClick={this.generalClickHandler.bind(this)}>
        <ToastContainer autoClose={5000} />
        <Row className="border border-light Scaffold-header">
          <a href={`/therapistDashboard/`}>
            <div
              className="flex-start border border-light logo_container"
              style={{ width: "200px" }}
            >
              <img
                src={this.props.label.logo}
                className="mt-2 Scaffold-logo"
                alt="Timocco Logo"
              />
            </div>
          </a>
          <div className="border-light">
            <Row className="ml-1 pt-3">
              <h1 className="text-left ml-3">
                {this.props.title}
                {this.props.info ? ":" : ""}
              </h1>
              {this.props.info && (
                <h3 className="mt-auto mb-1 ml-3 px-0 pb-2 text-secondary opacity-fade">
                  {this.props.info}
                </h3>
              )}
            </Row>
          </div>

          <div className="flex-grow-1 pt-4 ml-2 pl-5">
            <MasquaradeDropdown
              masquaradeUsers={masquaradeUsers}
              masquaradeUserCount={masquaradeUserCount}
              displayUserRole={Constants.ADMIN_ROLE_LEVEL}
              currentUserRole={user.roleLevel}
              isMasquaraded={isMasquaraded}
              onSearchChange={(value) => this.onSearchChange(value, token)}
              onSelectUser={(id) => this.onSelectUser(id, token)}
              onRevertMasquarade={() => this.onRevertMasquarade(token)}
            ></MasquaradeDropdown>
          </div>

          <GamificationMenuToggler token={token} user={user} profile_route={profileRoute} history={this.props.history}/>
        </Row>

        {this.adminRouter(isWorldCupUser)}
      </div>
      </Router>
    );
  }

  generalClickHandler() {
    const { lastKeepAlive } = this.state;
    let currentTime = Math.floor(Date.now() / 1000);
    if (lastKeepAlive) {
      if (currentTime - lastKeepAlive < KEEP_ALIVE_INTERVAL) {
        return;
      }
    }
    let { token } = this.props;
    this.props.dispatch(keepAlive(token));

    this.setState({
      lastKeepAlive: currentTime,
    });
  }

  displayRegionalBusinessGroupAdminScaffold(profileRoute) {
    const {
      masquaradeUsers,
      masquaradeUserCount,
      token,
      isMasquaraded,
      user,
      label,
    } = this.props;
    return (
      <Router>
      <div onClick={this.generalClickHandler.bind(this)}>
        <ToastContainer autoClose={5000} />
        <Row className="border border-light Scaffold-header">
          <a href={`/manager-dashboard/`}>
            <div
              className="flex-start border border-light logo_container"
              style={{ width: "200px" }}
            >
              <img
                src={label.logo}
                className="mt-2 Scaffold-logo"
                alt="Timocco Logo"
              />
            </div>
          </a>

          <div className="flex-grow-1 pt-4 ml-2 pl-5">
            <MasquaradeDropdown
              masquaradeUsers={masquaradeUsers}
              masquaradeUserCount={masquaradeUserCount}
              displayUserRole={Constants.ADMIN_ROLE_LEVEL}
              currentUserRole={user.roleLevel}
              isMasquaraded={isMasquaraded}
              onSearchChange={(value) => this.onSearchChange(value, token)}
              onSelectUser={(id) => this.onSelectUser(id, token)}
              onRevertMasquarade={() => this.onRevertMasquarade(token)}
            ></MasquaradeDropdown>
          </div>

          <div className="border-light">
            <Row className="ml-1 pt-3">
              <h1 className="text-left ml-3">
                {this.props.title}
                {this.props.info ? ":" : ""}
              </h1>
              {this.props.info && (
                <h3 className="mt-auto mb-1 ml-3 px-0 pb-2 text-secondary opacity-fade">
                  {this.props.info}
                </h3>
              )}
            </Row>
          </div>
          <div className="flex-grow-1" key="exit-icon">
            <GamificationMenuToggler token={token} user={user} profile_route={profileRoute} history={this.props.history}/>
          </div>
        </Row>

        
          <div className="d-flex Scaffold-container">
            <Sidebar />
            <div className="flex-grow-1 Scaffold-content">
              <Switch>
                <Route path={"/teamMember/:id"} component={TeamMemberForm} />
                <Route exact path={"/"} component={RegionalManagerDashboard} />
                <Route
                  exact
                  path={"/manager-dashboard"}
                  component={RegionalManagerDashboard}
                />
                <Route
                  path={"/stats-dashboard"}
                  component={MetabaseDashboard}
                />
              </Switch>
            </div>
          </div>
      </div>
      </Router>
    );
  }

  displayPlayerScaffold(profileRoute) {
    const {
      masquaradeUsers,
      masquaradeUserCount,
      token,
      isMasquaraded,
      user,
      label,
    } = this.props;
    return (
      <Router>
      <div onClick={this.generalClickHandler.bind(this)}>
        <ToastContainer autoClose={5000} />
        <Row className="border border-light Scaffold-header">
          <a href={`/home-player-dashboard/`}>
            <div
              className="flex-start border border-light logo_container"
              style={{ width: "200px" }}
            >
              <img
                src={label.logo}
                className="mt-2 Scaffold-logo"
                alt="Timocco Logo"
              />
            </div>
          </a>
          <div className="flex-grow-1 pt-4 ml-2 pl-5">
            <MasquaradeDropdown
              masquaradeUsers={masquaradeUsers}
              masquaradeUserCount={masquaradeUserCount}
              displayUserRole={Constants.ADMIN_ROLE_LEVEL}
              currentUserRole={user.roleLevel}
              isMasquaraded={isMasquaraded}
              onSearchChange={(value) => this.onSearchChange(value, token)}
              onSelectUser={(id) => this.onSelectUser(id, token)}
              onRevertMasquarade={() => this.onRevertMasquarade(token)}
            ></MasquaradeDropdown>
          </div>
          <div className="border-light">
            <Row className="ml-1 pt-3">
              <h1 className="text-left ml-3">
                {this.props.title}
                {this.props.info ? ":" : ""}
              </h1>
              {this.props.info && (
                <h3 className="mt-auto mb-1 ml-3 px-0 pb-2 text-secondary opacity-fade">
                  {this.props.info}
                </h3>
              )}
            </Row>
          </div>
          <GamificationMenuToggler token={token} user={user} profile_route={profileRoute} history={this.props.history}/>
        </Row>

          <div className="d-flex Scaffold-container">
            <Sidebar />
            <div className="flex-grow-1 Scaffold-content">
              <Switch>
                <Route exact path={"/"} component={HomePlayerDashboard} />
                <Route
                  exact
                  path={"/home-player-dashboard"}
                  component={HomePlayerDashboard}
                />
                <Route path={"/teamMember/:id"} component={TeamMemberForm} />
              </Switch>
            </div>
          </div>
      </div>
      </Router>
    );
  }

  displayCarePartnerScaffold(profileRoute) {
    const {
      masquaradeUsers,
      masquaradeUserCount,
      token,
      isMasquaraded,
      user,
      label,
    } = this.props;
    return (
      <Router>
      <div onClick={this.generalClickHandler.bind(this)}>
        <ToastContainer autoClose={5000} />
        <Row className="border border-light Scaffold-header">
          <a href={`/care-partner-dashboard/`}>
            <div
              className="flex-start border border-light logo_container"
              style={{ width: "200px" }}
            >
              <img
                src={label.logo}
                className="mt-2 Scaffold-logo"
                alt="Timocco Logo"
              />
            </div>
          </a>
          <div className="flex-grow-1 pt-4 ml-2 pl-5">
            <MasquaradeDropdown
              masquaradeUsers={masquaradeUsers}
              masquaradeUserCount={masquaradeUserCount}
              displayUserRole={Constants.ADMIN_ROLE_LEVEL}
              currentUserRole={user.roleLevel}
              isMasquaraded={isMasquaraded}
              onSearchChange={(value) => this.onSearchChange(value, token)}
              onSelectUser={(id) => this.onSelectUser(id, token)}
              onRevertMasquarade={() => this.onRevertMasquarade(token)}
            ></MasquaradeDropdown>
          </div>
          <div className="border-light">
            <Row className="ml-1 pt-3">
              <h1 className="text-left ml-3">
                {this.props.title}
                {this.props.info ? ":" : ""}
              </h1>
              {this.props.info && (
                <h3 className="mt-auto mb-1 ml-3 px-0 pb-2 text-secondary opacity-fade">
                  {this.props.info}
                </h3>
              )}
            </Row>
          </div>
          <div className="flex-grow-1" key="exit-icon">
            <GamificationMenuToggler token={token} user={user} profile_route={profileRoute} history={this.props.history}/>
          </div>
        </Row>
          <div className="d-flex Scaffold-container">
            <Sidebar />
            <div className="flex-grow-1 Scaffold-content">
              <Switch>
                <Route exact path={"/"} component={CarePartnerDashboard} />
                <Route
                  exact
                  path={"/care-partner-dashboard"}
                  component={CarePartnerDashboard}
                />
                <Route path={"/teamMember/:id"} component={TeamMemberForm} />
              </Switch>
            </div>
          </div>
      </div>
      </Router>
    );
  }

  render() {
    let { user, toggleRoutingRender } = this.props;
    let profileRoute = `/teamMember/${user.currentUserId}/`;

    let isWorldCupUser =
      user.currentUserFirstName === "Fun" && user.organization === 1;

    let scaffold = (
      <div className="scaffold_loading">
        Preparing your dashboard... <i className="fa fa-spinner fa-spin"></i>
      </div>
    );
    if (user.roleLevel === null) {
      return scaffold;
    }
    if (
      user.roleLevel === Constants.ADMIN_ROLE_LEVEL ||
      user.roleLevel === Constants.ORGANIZATION_ADMIN_ROLE_LEVEL ||
      user.roleLevel === Constants.THERAPIST_ROLE_LEVEL
    ) {
      scaffold = this.renderAdminScaffold(user, profileRoute, isWorldCupUser);
    } else if (user.roleLevel === Constants.PLAYER_ROLE_LEVEL) {
      scaffold =  this.displayPlayerScaffold(profileRoute);
    } else if (user.roleLevel === Constants.CARE_PARTNER_ROLE_LEVEL) {
      scaffold =  this.displayCarePartnerScaffold(profileRoute);
    } else if (
      user.roleLevel === Constants.REGIONAL_ADMIN_ROLE_LEVEL ||
      user.roleLevel === Constants.BUSINESS_GROUP_ADMIN_ROLE_LEVEL
    ) {
      scaffold =  this.displayRegionalBusinessGroupAdminScaffold(profileRoute);
    }

    return(
      <div>
        <ConstantsModifier />
        <DatadogUserTagger user={user} />
        <span disabled={toggleRoutingRender}>.</span>
        {scaffold}
      </div>
    )
  }
}

const withState = connect((state) => {
  const { role, user, masquarade} = state;

  return {
    roles: role.roles,
    // users: users,
    user: user,
    token: user.token,
    masquaradeUsers: masquarade.masquaradeUsers,
    masquaradeUserCount: masquarade.masquaradeUserCount,
    isMasquaraded: user.isMasquaraded,
  };
});

export default withWhiteLabelContext(withRouter(withState(Scaffold)));



// WEBPACK FOOTER //
// ./src/components/containers/scaffold/scaffold.js